import styles from "./ReturnBackButton.module.css";
import { Button } from "@mui/material";
import Btn from "../btn/btn";
import { useNavigate } from "react-router";
import { ArrowBack, Logout } from "@mui/icons-material";
import { useContext } from "react";
import { AppContext } from "../../context/context";

export default function ReturnBackButton({ url = "/tramites" }) {
  const { user, closeSession } = useContext(AppContext);
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <a href={url}>
        <Button startIcon={<ArrowBack />} color="success" variant="text">
          Volver
        </Button>
      </a>

      {user && (
        <Button
          startIcon={<Logout fontSize="small" />}
          onClick={() => closeSession()}
          variant="outlined"
          color="error"
        >
          Cerrar sesión
        </Button>
      )}
    </div>
  );
}
